// (function() {
//   // Function to get query parameters from URL
//   function getQueryParam(param) {
//     var urlParams = new URLSearchParams(window.location.search);
//     return urlParams.get(param);
//   }

//   // Check if utm_source is 'qr_code'
//   var utmSource = getQueryParam('utm_source');
//   if (utmSource === 'qr_code') {
//     // Redirect to the desired URL
//     window.location.href = '/pages/traceability';
//   }
// })();

document.addEventListener("DOMContentLoaded", function() {
    function getQueryParam(param) {
        var params = new URLSearchParams(window.location.search);
        return params.get(param);
    }

    var utmSource = getQueryParam('utm_source');
    if (utmSource === 'qr_code') {
        window.location.href = '/pages/traceability';
    }
});